import React, { useState } from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../event-create/Urls';
import DataCard from '../profile-edit/DataCard';
import { PayloadStates } from '@lore/utils';
import useEventTags from '../../hooks/useEventTags';
import TagTypes from '../../constants/TagTypes';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function Subjects(props) {
  const { event } = props;

  const { history } = usePageRouter();

  const [timestamp] = useState(new Date().toISOString());

  const eventSubjects = useEventTags(event, TagTypes.Subject, timestamp);

  let subtitle = '';

  if (eventSubjects.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = eventSubjects.data.map(function(eventSubject) {
      return eventSubject.data.name;
    }).join(', ');
  }

  return (
    <DataCard
      title="Subjects"
      icon={BookOpenIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(event).SUBJECTS)}
    />
  );
};
